import type { Error } from '@ps/web-shared-validators';
import { noWhiteStartOrEnd, required } from '@ps/web-shared-validators';
import React from 'react';

import type { FieldNameProp } from '@swf/core/types/Props';

import { maxLength, postalCode } from '../../validators/postalCode';
import TextInput from '../TextInput/TextInput';

import {
  TXTWCL_Please_enter_your_postcode_ZIP_ELL,
  TXTWCL_Zip_Postcode
} from './PostalCode.messages.json';

interface Props extends FieldNameProp {
  country: string;
  requiredMessage?: Error['message'];
  value?: string;
}

const normalize: Record<string, (value: string) => string> = {
  DK: (value: string) => value.replace(/\D/g, ''),
  IT: (value: string) => value.replace(/\D/g, ''),
  GB: (value: string) => {
    const trimmedCode = value.toLocaleUpperCase().replace(/\s/g, '');
    const formattedCode = trimmedCode.replace(/^([a-z]{1,2}\d[a-z\d]?)\s*(\d[a-z]{2})$/i, '$1 $2');
    return formattedCode ? formattedCode : value;
  },
  PT: (value: string) => {
    const match = value.match(/^(\d{4})(\d{3})$/);
    return match ? match.slice(1).join('-') : value;
  },
  GR: (value: string) => value.trim()
};

const trimCharsFactory = (value: string) => {
  if (!value) {
    return '';
  }

  return value.replace(/[^0-9A-Za-z /*/-]/g, '');
};

const PostalCode: React.FC<Props> = ({
  country,
  fieldName,
  requiredMessage = TXTWCL_Please_enter_your_postcode_ZIP_ELL,
  value
}) => (
  <TextInput
    id={fieldName}
    label={TXTWCL_Zip_Postcode}
    maxLength={maxLength}
    autoComplete="off"
    value={value}
    checkDisabled
    format={(value) => trimCharsFactory(value)}
    parse={(value) =>
      country && normalize[country] ? normalize[country](value) : trimCharsFactory(value)
    }
    validators={[noWhiteStartOrEnd, required(requiredMessage), postalCode(country)]}
  />
);

export default PostalCode;
